export default {
  biller_disbursement_account_id: [
    {required: true}
  ],
  sponsor_id: [
    {required: true},
  ],
  sponsor_account: [
    {required: true},
  ],
  sponsor_fee: [
    {required: true},
  ]
}
